
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiConnectorCorner as ObiConnectorCornerElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-connector-corner.js';
 
 
 

 
 export const ObiConnectorCorner = createComponent({
   react: React,
   tagName: 'obi-connector-corner',
   elementClass: ObiConnectorCornerElement,
   events: {
     
   }
  });
 
 